import React from 'react'
import { Text } from '@mantine/core'

interface SectionTitleWithDecorProps {
  children: React.ReactNode
}

const SectionTitleWithDecor: React.FC<SectionTitleWithDecorProps> = ({ children }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px 0',
      }}
    >
      <div
        style={{
          width: 64,
          height: 4,
          background: 'linear-gradient(117deg, rgba(251,246,222,0) 0%, #FBF6DE 100%)',
          borderRadius: 2,
          marginRight: 12,
          boxShadow: '0 0 8px rgba(251, 246, 222, 0.3)',
        }}
      />

      <div
        style={{
          position: 'relative',
          padding: '8px 16px',
          background: 'linear-gradient(135deg, rgba(251, 246, 222, 0.1) 0%, rgba(251, 246, 222, 0.05) 100%)',
          borderRadius: 12,
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(251, 246, 222, 0.2)',
        }}
      >
        <Text
          style={{
            fontWeight: 700,
            fontSize: 22,
            color: '#FBF6DE',
            lineHeight: '28px',
            textAlign: 'center',
            fontStyle: 'normal',
            textTransform: 'none',
            margin: 0,
            padding: 0,
            minWidth: 120,
            textShadow: '0 0 5px rgba(251, 246, 222, 0.5)',
          }}
        >
          {children}
        </Text>
      </div>

      <div
        style={{
          width: 64,
          height: 4,
          background: 'linear-gradient(117deg, #FBF6DE 0%, rgba(251,246,222,0) 100%)',
          borderRadius: 2,
          marginLeft: 12,
          boxShadow: '0 0 8px rgba(251, 246, 222, 0.3)',
        }}
      />
    </div>
  )
}

export default SectionTitleWithDecor
